import { render, staticRenderFns } from "./LegacySnapshot.vue?vue&type=template&id=b8a0bafa"
import script from "./LegacySnapshot.vue?vue&type=script&lang=js"
export * from "./LegacySnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports